import { createSlice } from '@reduxjs/toolkit'

export const modalSlice = createSlice({
    name: 'modal',
    initialState: { 
        bodyTypes : [],   
        extraObjects : {},  
        formStates: {}
    },
    reducers: {
        openModal: (state, action) => {
            const {bodyTypesData, extraObjectsData, formStatesData} = action.payload
            state.bodyTypes = bodyTypesData
            state.extraObjects = extraObjectsData
            if (formStatesData) {
                state.formStates = formStatesData
            }
        },
        closeModal: (state, action) => {
            const {bodyTypesData, extraObjectsData, formStatesData} = action.payload
            state.bodyTypes = bodyTypesData
            state.extraObjects = extraObjectsData === true ? {} : extraObjectsData
            if (formStatesData) {
                state.formStates = formStatesData
            }
        },
        setFormState: (state, action) => {
            const {formStatesData} = action.payload
            state.formStates = formStatesData
        }
    }
})

export const { openModal, closeModal, setFormState } = modalSlice.actions

export default modalSlice.reducer